export const PACKAGING_REF_FOR_DOCUMENTS: string = '1499fa48-d26e-11e1-95e4-0026b97ed48a';
export const PACKAGING_REF_FOR_PARCEL: string = 'cd00107e-2e73-41eb-9056-85a9931c6223';

export const PACKAGING_PRICE_FOR_DOCUMENTS_FROM_POSTBOX: number = 0;
export const PACKAGING_PRICE_FOR_PARCEL_FROM_POSTBOX: number = 15;
